import { useParticipants } from "@livekit/components-react";
import { Room } from "../../../hooks/api";
import classNames from "./EventTitles.module.css";
import { useMemo } from "react";
import EventDate from "./EventDate";
import { getLanguageName } from "../../../types";

const Participants = () => {
  const participants = useParticipants();
  const numParticipants = useMemo(() => {
    return participants
      .filter((p) => !p.isAgent)
      .filter((p) => !!p.metadata)
      .filter((p) => {
        try {
          const metadata = JSON.parse(p.metadata!) as {
            participant_type: string;
          };
          return metadata.participant_type === "viewer";
        } catch {
          // Ignore error
        }
        return false;
      }).length;
  }, [participants]);

  return (
    <>
      {" "}
      · {numParticipants} participant{numParticipants === 1 ? "" : "s"}
    </>
  );
};

const EventTitles = (props: { room: Room; hideParticipants?: boolean }) => {
  return (
    <div className={classNames.EventTitles}>
      <h2>{props.room.name}</h2>
      {props.room.start_time && props.room.end_time && (
        <p>
          <EventDate
            start={props.room.start_time.toString()}
            end={props.room.end_time.toString()}
            reoccurring={props.room.reoccurring}
          />
        </p>
      )}
      <p>
        {props.room.languages.map((l) => getLanguageName(l)).join(", ")}
        {!props.hideParticipants && <Participants />}
      </p>
    </div>
  );
};

export default EventTitles;
